/* The preview explains existing bundles; it never selects delivery days or changes a cart. */
(function () {
  'use strict';
  if (window.bbHomeBoot) { window.bbHomeBoot(document); return; }
  var bundles = {
    complete: { foods: ['main', 'salad', 'indian', 'snack'], label: 'Main meal + salad + Indian meal + nuts or a protein bar.' },
    salad: { foods: ['main', 'salad', 'snack'], label: 'Main meal + salad + nuts or a protein bar.' },
    indian: { foods: ['main', 'indian', 'snack'], label: 'Main meal + Indian meal + nuts or a protein bar.' },
    main: { foods: ['main', 'snack'], label: 'Main meal + nuts or a protein bar.' }
  };
  function mount(root) {
    if (root.bbHome) return;
    var preview = root.querySelector('[data-bb-box-preview]');
    var note = root.querySelector('[data-bb-combo-note]');
    var link = root.querySelector('[data-bb-combo-link]');
    var picker = root.querySelector('.bb-combo-picker');
    if (!preview || !note || !link || !picker) return;
    function update(event) {
      var input = event && event.target;
      if (!input || !input.matches('input[type="radio"]') || !Object.prototype.hasOwnProperty.call(bundles, input.value)) return;
      var bundle = bundles[input.value];
      preview.dataset.combo = input.value;
      preview.setAttribute('aria-label', bundle.label);
      preview.querySelectorAll('[data-bb-food]').forEach(function (food) {
        var included = bundle.foods.indexOf(food.dataset.bbFood) >= 0;
        food.classList.toggle('is-not-included', !included);
        var caption = food.querySelector('figcaption>span');
        if (caption) caption.textContent = !included ? 'Not in this combination' : (food.dataset.bbFood === 'main' || food.dataset.bbFood === 'snack' ? 'Always included' : 'Included');
      });
      note.textContent = bundle.label;
      link.href = link.dataset.bbProductUrl + '?bundle=' + encodeURIComponent(input.value);
    }
    picker.addEventListener('change', update);
    root.bbHome = { destroy: function () { picker.removeEventListener('change', update); delete root.bbHome; } };
  }
  function boot(scope) {
    if (scope.matches && scope.matches('[data-bb-home]')) mount(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-bb-home]').forEach(mount);
  }
  window.bbHomeBoot = boot; boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.matches && event.target.matches('[data-bb-home]') ? [event.target] : [];
    if (event.target.querySelectorAll) roots = roots.concat(Array.from(event.target.querySelectorAll('[data-bb-home]')));
    roots.forEach(function (root) { if (root.bbHome) root.bbHome.destroy(); });
  });
})();
